﻿﻿const DataInit = function(data){
    // http请求成功，取得返回对象
    let response = data;
    // 判断是否有属性IsSuccess，没有说明请求实际是失败的
    if (response.hasOwnProperty('IsSuccess')) {
        // 判断服务器是否处理成功
        if (response.IsSuccess) {
            // 返回content对象
            return Promise.resolve(response.Content)
        } else {
            // 判断是否是token失效错误
            if (!!response.ErrorCode && response.ErrorCode === errorCode.notoken) {
                // TODO 弹出token失效提示，并返回登录界面
                return Promise.reject('Session Error')
            } else {
                // 返回错误信息
                return Promise.reject(response.Msg)
            }
        }
    } else{
        return Promise.reject("Response format error")
    }
};

export {DataInit}



// WEBPACK FOOTER //
// ./src/api/dataInit.js